import { RelColumn } from "./relcolumn.model";
import { Aggregation } from "../enums";

export class RelRequestColumn extends RelColumn
{
  public IsCommaSeparated: boolean;
  public Aggregation: Aggregation;
}
